import React, { PropTypes, Component } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import { injectIntl, defineMessages } from 'react-intl'
import Feature from '../components/Feature'
import { messages as links } from '../app/App'
import './CalloutSection.scss'

const messages = defineMessages({
  hero: {
    id: 'callout.heroMessage',
    defaultMessage: 'Jak mít dlouhodobě zaplněný stadion?',
  },
  smartCrmHeader: {
    id: 'callout.smartCrm.header',
    defaultMessage: 'Chytré CRM',
  },
  smartCrmText: {
    id: 'callout.smartCrm.text',
    defaultMessage: `Poznejte své zákazníky a budujte s nimi
osobní vztahy ještě dnes! Poslouží Vám k tomu náš systém Stadyum CRM!`,
  },
  sellEffectivelyHeader: {
    id: 'callout.sellEffectively.header',
    defaultMessage: 'Prodávejte lístky efektivně',
  },
  sellEffectivelyText: {
    id: 'callout.sellEffectively.text',
    defaultMessage: `Umožněte divákům snadný nákup vstupenek
kdykoliv a kdekoliv prostřednictvím našeho partnera smsticket!`,
  },
})

const CalloutSection = ({ intl }) => (
  <section className="callout-section">
    <a name={intl.formatMessage(links.linkHowItWorksUrl)} id={intl.formatMessage(links.linkHowItWorksUrl)}></a>
    <h2>{intl.formatMessage(messages.hero)}</h2>
    <Grid>
      <Row>
        <Col sm={4} smOffset={2}>
          <Feature icon="bulb.svg" header={intl.formatMessage(messages.smartCrmHeader)}>
            <p className="description">
              {intl.formatMessage(messages.smartCrmText)}
            </p>
            <p className="stadyum-logo logo"><img src="/images/stadyum_logo.png" alt="staduym crm logo" /></p>
          </Feature>
        </Col>
        <Col sm={4}>
          <Feature icon="flag.svg" header={intl.formatMessage(messages.sellEffectivelyHeader)}>
            <p className="description">
              {intl.formatMessage(messages.sellEffectivelyText)}
            </p>
            <p className="smsticket-logo logo"><img src="/images/smsticket.svg" alt="smsticket logo" /></p>
          </Feature>
        </Col>
      </Row>
    </Grid>
  </section>
)

CalloutSection.propTypes = {
  intl: React.PropTypes.object.isRequired,
}

export default injectIntl(CalloutSection)



// WEBPACK FOOTER //
// ./src/browser/CalloutSection/CalloutSection.js